import axios from "./axios";

export const getRestaurants = () => axios.get().get(`/restaurants`)
